import Component from '@glimmer/component';

interface AditoolsMenuContextSignature {
  Blocks: {
    default: [];
  };
}
// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class AditoolsMenuContext extends Component<AditoolsMenuContextSignature> {}
